export const ALL_PRODUCTS = '__all__'
export const ALL_SITES = '__all__'

export interface DashboardFilterOption {
  code: string
  label: string
  employee_count: number
  call_count: number
}

export interface DashboardFilterContext {
  show_site_filter: boolean
  show_product_filter: boolean
  site_label: string
  product_label: string
}

export interface DashboardFilterOptions {
  available_products: DashboardFilterOption[]
  available_sites: DashboardFilterOption[]
  filter_context: DashboardFilterContext
}

export function appendScopeFilterParams(
  params: URLSearchParams,
  product?: string | null,
  site?: string | null,
) {
  if (product && product !== ALL_PRODUCTS) params.set('product', product)
  if (site && site !== ALL_SITES) params.set('site', site)
}
